import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogCloseButton,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
} from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonStyled } from "@/components/atoms";

type Props = {
  title: string;
  body?: string | React.JSX.Element;
  cancelText?: string;
  confirmText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
  isOpen: boolean;
  onClose: () => void;
};

export function AlertDialogStyled(props: Props) {
  const cancelRef = React.useRef(null);
  const { t } = useTranslation();

  return (
    <>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={props.onClose}
        isOpen={props.isOpen}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>{props.title}</AlertDialogHeader>
          <AlertDialogCloseButton />
          <AlertDialogBody>{props.body}</AlertDialogBody>
          <AlertDialogFooter>
            <Button
              ref={cancelRef}
              onClick={() => {
                props.onCancel?.();
                props.onClose();
              }}
            >
              {props.cancelText ?? t("common.cancel.text", { defaultValue: "Отмена" })}
            </Button>
            <ButtonStyled colorScheme="red" size={"md"} ml={3} onClick={props.onConfirm}>
              {props.confirmText ?? t("common.confirm.text", { defaultValue: "Подтвердить" })}
            </ButtonStyled>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
